export function computeLeakage(budget, contractValue) {
  const leads = Math.round(budget / 150)
  const lostTenths = leads * 2
  const leakage = Math.round((lostTenths * contractValue) / 10)
  return { leads, lostTenths, leakage }
}
